import { render } from "./HeadingComponent.vue?vue&type=template&id=37edfc02&scoped=true"
import script from "./HeadingComponent.vue?vue&type=script&lang=js"
export * from "./HeadingComponent.vue?vue&type=script&lang=js"

import "./HeadingComponent.vue?vue&type=style&index=0&id=37edfc02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37edfc02"]])

export default __exports__